(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mrp-cro-layer"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const layer = document.getElementById('MrpCroLayer');
      if (!layer || layer.dataset.ready === 'true') return;
      layer.dataset.ready = 'true';

      const threshold = Number(layer.dataset.shippingThreshold || 2500);
      const freeShippingEligible = layer.dataset.freeShippingEligible === 'true';
      const cartUrl = layer.dataset.cartUrl || '/cart';
      const currency = layer.dataset.currency || 'USD';
      const remainingTemplate = layer.dataset.remainingTemplate || 'Add [amount] more for free shipping.';
      const unlockedTemplate = layer.dataset.unlockedTemplate || 'Free shipping unlocked.';
      const progressTemplate = document.getElementById('MrpShippingProgressTemplate');
      let cartTotal = Number(layer.dataset.initialTotal || 0);
      let refreshTimer;

      const money = (cents) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency,
          }).format(Math.max(cents, 0) / 100);
        } catch (error) {
          return `$${(Math.max(cents, 0) / 100).toFixed(2)}`;
        }
      };

      const installDrawerProgress = () => {
        if (!freeShippingEligible) return;
        const footer = document.querySelector('#CartDrawer .drawer__footer');
        if (!footer || footer.querySelector('[data-mrp-shipping-progress]') || !progressTemplate) return;
        footer.prepend(progressTemplate.content.cloneNode(true));
      };

      const updateProgress = (total) => {
        if (!freeShippingEligible) return;
        cartTotal = Number.isFinite(Number(total)) ? Number(total) : cartTotal;
        installDrawerProgress();
        const remaining = Math.max(threshold - cartTotal, 0);
        const progress = Math.min((cartTotal / threshold) * 100, 100);
        const message = remaining > 0 ? remainingTemplate.replace('[amount]', money(remaining)) : unlockedTemplate;

        document.querySelectorAll('.mrp-shipping-progress').forEach((component) => {
          const messageElement = component.querySelector('.mrp-shipping-progress__message');
          const track = component.querySelector('.mrp-shipping-progress__track');
          const bar = component.querySelector('.mrp-shipping-progress__bar');
          if (messageElement && messageElement.textContent !== message) messageElement.textContent = message;
          if (track) {
            track.setAttribute('aria-label', message);
            track.setAttribute('aria-valuemax', String(threshold));
            track.setAttribute('aria-valuenow', String(Math.min(cartTotal, threshold)));
          }
          if (bar) bar.style.setProperty('--mrp-shipping-progress', `${progress}%`);
        });
      };

      const fetchCart = async () => {
        try {
          const response = await fetch(`${cartUrl}.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const cart = await response.json();
          updateProgress(cart.total_price);
        } catch (error) {
          updateProgress(cartTotal);
        }
      };

      const scheduleRefresh = (cartData) => {
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(() => {
          if (cartData && Number.isFinite(Number(cartData.total_price))) {
            updateProgress(cartData.total_price);
          } else {
            fetchCart();
          }
        }, 80);
      };

      if (freeShippingEligible) {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => scheduleRefresh(event && event.cartData));
        }

        document.addEventListener('cart:lines-update', () => scheduleRefresh());
        document.addEventListener('cart:refresh', () => scheduleRefresh());

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          new MutationObserver(() => scheduleRefresh()).observe(cartDrawer, { childList: true, subtree: true });
        }
      }

      const sticky = document.getElementById('MrpStickyAtc');
      const stickyButton = sticky && sticky.querySelector('[data-mrp-sticky-button]');
      const stickyLabel = sticky && sticky.querySelector('[data-mrp-sticky-label]');
      const stickyPrice = sticky && sticky.querySelector('[data-mrp-sticky-price]');
      let primaryButton;
      let primaryObserver;
      let visibilityObserver;

      const setStickyVisibility = (visible) => {
        if (!sticky) return;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('mrp-sticky-atc-visible', visible);
      };

      const syncSticky = () => {
        if (!sticky || !primaryButton) return;
        const label = primaryButton.querySelector('span');
        const price = document.querySelector('#MainContent [id^="price-"] .price-item--regular');
        stickyButton.disabled = primaryButton.disabled;
        if (label && stickyLabel) stickyLabel.textContent = label.textContent.trim();
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
      };

      const bindPrimaryButton = () => {
        const nextButton = document.querySelector(
          '#MainContent product-form form[data-type="add-to-cart-form"] .product-form__submit[name="add"]',
        );
        if (!nextButton || nextButton === primaryButton) return;

        primaryButton = nextButton;
        if (primaryObserver) primaryObserver.disconnect();
        if (visibilityObserver) visibilityObserver.disconnect();
        primaryObserver = new MutationObserver(syncSticky);
        primaryObserver.observe(primaryButton, { attributes: true, childList: true, subtree: true });
        visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passedButton = primaryButton.getBoundingClientRect().top < 0;
          setStickyVisibility(!entry.isIntersecting && passedButton);
        });
        visibilityObserver.observe(primaryButton);
        syncSticky();
      };

      if (stickyButton) {
        stickyButton.addEventListener('click', () => {
          if (!primaryButton || primaryButton.disabled) return;
          primaryButton.click();
        });

        const mainContent = document.getElementById('MainContent');
        if (mainContent) {
          new MutationObserver(bindPrimaryButton).observe(mainContent, { childList: true, subtree: true });
        }
        bindPrimaryButton();
      }

      if (freeShippingEligible) updateProgress(cartTotal);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
